<template>
  <div>

  </div>
</template>

<script>
export default {
    name: "Classroom",
    components:{

    },
    data(){
        return{

        }
    },
    created(){

    },
    methods:{

    }
}
</script>

<style lang="less">

</style>